<template>
<b-row align-v="center" align-h="center" class="mt-2" no-gutters>
    <b-modal id="modalbackdrop" ref="modalbackdrop" size="lg bigmodal" title="발송 내역 상세" :hide-backdrop="false" :no-close-on-backdrop="true">
        <b-row>
            <b-colxx xxs="12">
                <div>
                    <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
                        <b-col>
                            <b-form-group label="메세지 내용" label-size="lg" class="font-size-big">
                                <b-input-group size="sm">
                                    <span v-html="content.length !== 0 ?  changeMessage(content[0].message) : ''"></span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
                        <b-col>
                            <div class="text-right mb-3">
                                <download-excel :stringifyLongNum="true" :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="smsList.xls" type="xls">Excel
                                </download-excel>
                            </div>
                            <b-table head-variant="light" ref="general-table" class="vuetable" :currentpage="pageNumber" selectedVariant="primary" :items="content" :fields="fields" primary-key="settingId" responsive show-empty>
                                <template v-slot:cell(sendDateTime)="row">
                                    {{ $moment(row.item.sendDateTime).format('YYYY-MM-DD HH:mm')}}
                                </template>
                                <template v-slot:cell(message)="row">
                                    <span v-html="row.item.message"></span>
                                </template>
                                <template v-slot:cell(receiveMobileNo)="row">
                                    {{row.item.receiveMobileNo}}
                                </template>
                                <!-- <template v-slot:cell(status)="row">
                                    {{row.item.status === true ? '성공':'실패'}}
                                </template> -->
                                <template v-slot:empty>
                                    <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
                                </template>
                            </b-table>
                            <b-pagination v-if="lastPage > 1" size="sm" align="center" :total-rows="total" :per-page="pageSize" v-model="pageNumber">
                                <template v-slot:next-text>
                                    <i class="simple-icon-arrow-right" />
                                </template>
                                <template v-slot:prev-text>
                                    <i class="simple-icon-arrow-left" />
                                </template>
                                <template v-slot:first-text>
                                    <i class="simple-icon-control-start" />
                                </template>
                                <template v-slot:last-text>
                                    <i class="simple-icon-control-end" />
                                </template>
                            </b-pagination>
                        </b-col>
                    </b-row>
                </div>

            </b-colxx>
        </b-row>
        <template slot="modal-footer">
            <b-button variant="outline-primary" @click="messageCancel">취소</b-button>
            <b-button variant="outline-primary" style="display:none;"></b-button>
        </template>
    </b-modal>
</b-row>
</template>

<script>
import {
    alignTableCenter
} from '../../../utils';
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
import {
    rescode,
} from "../../../constants/common";
import {
    reqGet,
    reqPost
} from "../../../constants/request";
import api from '../../../constants/api';

export default {
    name: 'messageDetail',
    data() {
        return {
            excelData: [],
            mId: 0,
            perPage: 10,
            searchKeyword: '',
            total: 15,
            lastPage: 1,
            pageNumber: 1,
            pageSize: 20,
            totalPages: 0, //전체 페이지 수
            totalElements: 0, //전체 아이템 수
            numberOfElements: 0, //현재 조회된 아이템 수
            first: true, //첫 페이지일 경우 true
            last: false, //마지막 페이지일 경우 true
            content: [],
            fields: [{
                    key: 'sendDateTime',
                    label: '발송일',
                    ...alignTableCenter
                },
                {
                    key: 'receiveMobileNo',
                    label: '수신번호',
                    ...alignTableCenter
                },
                // {
                //     key: 'status',
                //     label: '상태',
                //     ...alignTableCenter
                // },
            ],
            json_fields: {
                '발송일': 'sendDateTime',
                '수신번호': 'receiveMobileNo',
            },
        }
    },
    watch: {
        pageNumber() {
            this.getListDetailPage(this.mId)
        }
    },
    mounted() {

    },
    computed: {
        ...mapGetters(['currentUser', 'siteName', 'brandInfo'])
    },
    filters:{
        
    },
    methods: {
        changeMessage(str){
            str = str.replace(/\r\n/ig, '<br>');
            str = str.replace(/\\n/ig, '<br>');
            str = str.replace(/\n/ig, '<br>');
            return str;
        },
        getListDetailPage(mId) {
            this.mId = mId;
            this.content = [];
            reqPost(
                api.changeAPI(this.siteName, api.basicURL + api.message.sms_history_detail_list_page),
                this.currentUser.tokens.access.token, {
                    keywordType: 'SmsHistoryId',
                    keyword: String(mId),
                    pageNumber: (this.pageNumber - 1),
                    pageSize: this.pageSize,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.content = result.data.content;
                            this.totalPages = result.data.totalPages; //전체 페이지 수
                            this.totalElements = result.data.totalElements; //전체 아이템 수
                            this.lastPage = result.data.totalPages;

                        } else {
                            this.content = [];
                            this.totalPages = 0; //전체 페이지 수
                            this.totalElements = 0; //전체 아이템 수
                            this.lastPage = 0;
                        }
                    }
                }
            );
        },
        async fetchData() {

            this.excelData = [];
            this.content.forEach((v, idx) => {
                // console.log(String(opnameOverlap).replace(/:/g,''))
                this.excelData.push({
                    'sendDateTime': this.$moment(v.sendDateTime).format('YYYY-MM-DD HH:mm'),
                    'receiveMobileNo': v.receiveMobileNo,
                })

            })
            return this.excelData
        },
        showModal() {
            this.$refs['modalbackdrop'].show();
        },
        messageCancel() {
            this.pageNumber = 1;
            this.$refs['modalbackdrop'].hide();
        },

    }
}
</script>

<style>

</style>
